import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./app";
import Auth0ProviderWithNavigate from "./auth0-provider-with-navigate";
import "./styles/styles.css";
import { Provider } from "react-redux";
import { store } from "src/state/store";

const container = document.getElementById("app-root") as HTMLElement;

const root = createRoot(container);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Auth0ProviderWithNavigate>
        <App />
      </Auth0ProviderWithNavigate>
    </BrowserRouter>
  </Provider>
);
